import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { figures: Object }

  async connect() {
    const { default: Chart } = await import("chart.js/auto")
    if (!this.element.isConnected) return

    this.chart = new Chart(this.element, {
      type: "bar",
      data: this.figuresValue,
      options: {
        aspectRatio: 3,
        scales: {
          x: { stacked: true },
          y: { stacked: true, beginAtZero: true }
        }
      }
    })
  }

  disconnect() {
    this.chart?.destroy()
  }
}
